import React from "react";
import ChatEditorLexical from "./messenger/components/ChatEditorLexical/ChatEditorLexical";

const NextEditorTest = ()=>{
    return (
        <div className="container">
            <div className="card big">
                <div>Test NextEditor</div>
                <ChatEditorLexical/>
            </div>
        </div>
    );
}

export default NextEditorTest;